import { Helmet } from "react-helmet-async";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../context/AlertContext";
import {
  Button,
  Card,
  Container,
  Form,
  Image,
  Tab,
  Row,
  Col,
  Tabs
} from "react-bootstrap";
import Table from "../../../components/Table";
import {
  CloseIcon,
  ImageFileIcon,
  UploadCloudIcon
} from "../../../data/iconImage";
import { readExcelFileNew } from "../../../commons/FileHandler";
import ConfirmModal from "../../../components/ConfirmModal";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import EventPlanningDetail from "./Tabs/EventPlaningDetail";
import WorkCalendar from "./Tabs/calendar";
import { formatDate, formatDateFromXlxs } from "../../../commons/FormatValue";
import moment from "moment";
import TechnicianPlansService from "../../../services/technicianplan.service";

export default function ImportHeadEventPlanning() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [fileChange, setFileChange] = useState();
  const [dataImportExcel, setDataImportExcel] = useState([]);
  console.log(
    "🚀 ~ ImportHeadEventPlanning ~ dataImportExcel:",
    dataImportExcel
  );
  const [selectedTab, setSelectedTab] = useState("EventPlanning");

  useEffect(() => {
    handleChangeTab("EventPlanning");
  }, []);

  const handleChangeTab = (key) => {
    switch (key) {
      case "EventplaningDetail":
        setWebsiteName("ข้อมูลการวางแผน");
        setSelectedTab("EventplaningDetail");
        navigate("/service_work/planning", {
          replace: true,
          state: "EventplaningDetail"
        });
        break;
      case "EventplaningCalendar":
        setWebsiteName("ปฏิทินงานช่าง");
        setSelectedTab("EventplaningCalendar");
        navigate("/service_work/planning", {
          replace: true,
          state: "EventplaningCalendar"
        });
        break;
      default:
        setWebsiteName("หัวหน้าวางแผนงาน");
        setSelectedTab("EventPlanning");
    }
  };

  // const columnsImportExcel = [
  //   {
  //     name: "ลำดับ",
  //     selector: (row) => row.rowIndex,
  //     sortable: true,
  //     width: "110px"
  //   },
  //   {
  //     name: "ประเภทงาน",
  //     selector: (row) => row.jobtype_name,
  //     sortable: true,
  //     sortable: true,
  //     width: "200px"
  //   },
  //   {
  //     name: "เลขที่ใบสั่งงาน",
  //     selector: (row) => row.Service_req_no,
  //     sortable: true,
  //     width: "250px"
  //   },
  //   {
  //     name: "รหัสลูกค้า/สาขา",
  //     selector: (row) => row.Cus_code,
  //     sortable: true,
  //     width: "250px"
  //   },
  //   {
  //     name: "ชื่อลูกค้า/สาขา",
  //     selector: (row) => row.Cus_name,
  //     sortable: true,
  //     width: "250px"
  //   },
  //   {
  //     name: "รายละเอียดสินค้า",
  //     selector: (row) => row.Item_name,
  //     sortable: true,
  //     width: "250px"
  //   },
  //   {
  //     name: "วันที่เข้างานระหว่าง",
  //     selector: (row) => row.job_start_date,
  //     sortable: true,
  //     width: "250px"
  //   },
  //   {
  //     name: "ถึงวันที่",
  //     selector: (row) => row.job_finish_date,
  //     sortable: true,
  //     width: "250px"
  //   },
  //   {
  //     name: "วันที่เข้างานจริง",
  //     selector: (row) => row.job_actual_date,
  //     sortable: true,
  //     width: "250px"
  //   },
  //   {
  //     name: "ช่างผู้ปฏิบัติงาน",
  //     selector: (row) => row.technician_name,
  //     sortable: true,
  //     width: "250px"
  //   },
  //   {
  //     name: "สถานะงานช่าง",
  //     selector: (row) => row.depart_name,
  //     sortable: true,
  //     width: "250px"
  //   },
  //   {
  //     name: "สถานะใบสั่งงาน",
  //     selector: (row) => row.seq_st_name,
  //     sortable: true,
  //     width: "250px"
  //   }
  // ];
  const keys = {
    Cus_Name: "ชื่อลูกค้า/สาขา",
    Job_Type_Name: "ประเภทงาน",
    Seq_St_Code: "เลขที่ใบสั่งงาน",
    Cus_Code: "รหัสลูกค้า/สาขา",
    Job_Type_Name: "ประเภทงาน",
    Job_Cus_Date: "วันที่เข้างานระหว่าง",
    Job_End_Date: "ถึงวันที่",
    Job_Actual_Date: "วันที่เข้างานจริง",
    Tech_Mas_Name: "ช่างผู้ปฏิบัติงาน",
    Depart_St_Name: "สถานะงานช่าง",
    Seq_St_Name: "สถานะใบสั่งงาน"
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    const checkSize = 5 * 1024 * 1024;

    if (file) {
      if (file.size > checkSize) {
        setLoading(false);
        return showAlert({
          error: "คำเตือน",
          message: "ต้องเป็นไฟล์ .xlsx ขนาดไม่เกิน 25 MB",
          type: "warning"
        });
      }
      try {
        setLoading(true);
        const jsonData = await readExcelFileNew(file);
        const mappedData = jsonData.map((item) => {
          const newItem = {};
          Object.keys(keys).forEach((key) => {
            const dataKey = keys[key];
            newItem[key] = item[dataKey];
          });
          return newItem;
        });

        setDataImportExcel(mappedData);
        setFileChange(file);

        setLoading(false);
      } catch (error) {
        setFileChange();
        setLoading(false);
        return showAlert({
          error: "คำเตือน",
          type: "warning"
        });
      }
    }
    event.target.value = null;
  };

  const handleSubmit = async (event, dataCallback) => {
    console.log(dataCallback);
    const response = await TechnicianPlansService.createTechnicianPlans();
    navigate("/service_work/planning", {
      replace: true,
      state: "EventPlanning"
    });
  };

  const handleCancleUpload = (dataCallback) => {
    setFileChange(null);
    setDataImportExcel([]);
    navigate("/service_work/planning", {
      replace: true,
      state: "EventPlanning"
    });
  };
  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row?.rowIndex,
      sortable: true,
      width: "110px"
    },
    {
      name: "ประเภทงาน",
      selector: (row) => row?.Job_Type_Name,
      sortable: true,
      width: "200px"
    },
    {
      name: "เลขที่ใบสั่งงาน",
      selector: (row) => row?.Seq_St_Code,
      sortable: true,
      width: "200px"
    },
    {
      name: "รหัสลูกค้า/สาขา",
      selector: (row) => row?.Cus_Code,

      sortable: true,
      width: "200px"
    },
    {
      name: "ชื่อลูกค้า/สาขา",
      selector: (row) => row?.Cus_Name,
      sortable: true,
      width: "200px"
    },
    {
      name: "รายละเอียดสินค้า",
      selector: (row) => row.Cus_code,
      sortable: true,
      width: "200px"
    },
    {
      name: "วันที่เข้างานระหว่าง",
      selector: (row) => formatDateFromXlxs(row?.Job_Cus_Date),
      sortable: true,
      width: "200px"
    },
    {
      name: "ถึงวันที่",
      selector: (row) => formatDate(row?.Job_End_Date),
      sortable: true,
      width: "200px"
    },
    {
      name: "วันที่เข้างานจริง",
      selector: (row) => formatDate(row?.Job_Actual_Date),
      sortable: true,
      width: "200px"
    },
    {
      name: "ช่างผู้ปฏิบัติงาน",
      selector: (row) => row?.Tech_Mas_Name,
      sortable: true,
      width: "200px"
    },
    {
      name: "สถานะงานช่าง",
      selector: (row) => row?.Depart_St_Name,
      sortable: true,
      width: "200px"
    },
    {
      name: "สถานะใบสั่งงาน",
      selector: (row) => row?.Seq_St_Name,
      sortable: true,
      width: "200px"
    }
  ];

  const handleDeleteFile = () => {
    setFileChange();
    setDataImportExcel([]);
  };
  return (
    <>
      <Helmet>
        <title>หัวหน้าวางแผนงาน</title>
        <meta name="description" content="Head Event Planning Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs
          justify
          defaultActiveKey={"EventPlanning"}
          onSelect={(k) => handleChangeTab(k)}
        >
          <Tab eventKey="EventPlanning" title="หัวหน้าวางแผนงาน">
            <Form onSubmit={handleSubmit}>
              <Card className="m-1 mb-4 p-4 border-0">
                <Card.Header className="p-3 fs-2 text-dark text-center bg-transparent border-bottom-0">
                  นำเข้าจาก Excel
                </Card.Header>

                <Card.Body>
                  <Form.Group
                    controlId="importExcel"
                    className="w-100 p-4"
                    style={{ border: "1px dashed #B4B4B4" }}
                  >
                    <Form.Label className="mb-0 p-2 d-flex flex-column justify-content-center align-items-center rounded-4">
                      <Image
                        className="mb-4"
                        src={UploadCloudIcon}
                        alt="Upload Cloud Icon"
                      />
                      <Form.Text className="fs-4 text-black">
                        เลือกไฟล์ที่ต้องการ หรือลากและวางที่นี่
                      </Form.Text>
                      <Form.Text className="fs-4 text-dark-emphasis">
                        ต้องเป็นไฟล์ .xlsx ขนาดไม่เกิน 5 MB
                      </Form.Text>
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept=".xlsx"
                      className="d-none"
                      onChange={handleFileChange}
                    />
                  </Form.Group>
                </Card.Body>

                {fileChange && (
                  <Card.Footer className="p-3 bg-transparent border-top-0">
                    <Card className="p-3 position-relative d-flex flex-row justify-content-between align-items-center bg-body-tertiary border-0">
                      <Card.Title
                        className="mb-0 fw-normal d-flex align-items-center"
                        style={{ fontSize: "12px" }}
                      >
                        <Card.Img
                          className="w-auto me-3"
                          src={ImageFileIcon}
                          alt="Image File Icon"
                        />
                        {fileChange.name}
                      </Card.Title>

                      <Card.Text style={{ fontSize: "12px" }}>
                        {Math.round(fileChange.size / (1024 * 1024)) > 1
                          ? `${Math.round(fileChange.size / (1024 * 1024))}MB`
                          : `${Math.round(fileChange.size / 1024)}KB`}
                      </Card.Text>

                      <Button
                        variant="danger"
                        className="h-auto ms-0 p-1 d-flex align-items-center position-absolute top-0 start-100 translate-middle rounded-pill"
                        onClick={handleDeleteFile}
                      >
                        <Image
                          width="16px"
                          height="16px"
                          src={CloseIcon}
                          alt="Close Icon"
                          style={{
                            filter:
                              "invert(100%) sepia(0%) saturate(7500%) hue-rotate(1deg) brightness(100%) contrast(101%)"
                          }}
                        />
                      </Button>
                    </Card>
                  </Card.Footer>
                )}
              </Card>

              {/* {data.length > 0 && ( */}
              <Card className="m-1 mb-4 p-4 border-0">
                <Card.Body>
                  <Table
                    data={dataImportExcel}
                    column={columns}
                    pending={loading}
                    pagination
                  />
                </Card.Body>

                <Card.Footer className="py-3 text-center bg-transparent border-top-0">
                  <Button
                    variant="success"
                    className="px-5 py-2 text-dark rounded-pill"
                    onClick={() => {
                      if (dataImportExcel.length > 0) {
                        setShowModal(!showModal);
                      } else {
                        showAlert({
                          error: "คำเตือน",
                          message: "กรุณาเลือก Excel File ก่อน",
                          type: "warning"
                        });
                      }
                    }}
                  >
                    นำเข้าข้อมูล
                  </Button>

                  <Button
                    variant="outline-secondary"
                    className="px-5 py-2 text-dark rounded-pill"
                    onClick={handleCancleUpload}
                  >
                    ยกเลิก
                  </Button>
                </Card.Footer>
              </Card>
              <ConfirmModal
                show={showModal}
                data={dataImportExcel.length > 0 ? dataImportExcel[0] : null}
                content={"save"}
                onSubmitCallback={handleSubmit}
              />
              {/* )} */}
            </Form>
            {/* <Card className="m-1 mb-4 p-4 border-0">
              <Card.Body>
                <Table
                  data={data}
                  column={columns}
                  pending={loading} />
              </Card.Body>
              <Row className="mt-3 text-center">
                <Col className="mt-3">
                  <Button
                    type="submit"
                    variant="success"
                    className="me-2 px-5 py-2 text-dark rounded-pill"
                    onClick={() => setShowModal(!showModal)}
                  >
                    บันทึกข้อมูล
                  </Button>
                  <ConfirmModal
                    show={showModal}
                    data={data}
                    content={"save"}
                    onSubmitCallback={handleSubmit}
                  />

                  <Button
                    variant="outline-success"
                    className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
                    onClick={() =>
                      navigate("/service_work/planning", {
                        state: "EventPlanning"
                      })
                    }
                  >
                    ยกเลิก
                  </Button>
                </Col>
              </Row>
            </Card> */}
          </Tab>
          <Tab eventKey="EventplaningDetail" title="ข้อมูลการวางแผน">
            {websiteName === "ข้อมูลการวางแผน" && <EventPlanningDetail />}
          </Tab>
          <Tab eventKey="EventplaningCalendar" title="ปฏิทินงานช่าง">
            {websiteName === "ปฏิทินงานช่าง" && <WorkCalendar />}
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
